import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}`;

const requestConfig = (token, params = {}) => ({
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
  params,
});

const loginAnalyticsService = {
  getSummary: async (token, params) => {
    const response = await axios.get(
      `${API_BASE_URL}/admin/login-attempts/summary`,
      requestConfig(token, params)
    );
    return response.data;
  },

  getFailureReasons: async (token, params) => {
    const response = await axios.get(
      `${API_BASE_URL}/admin/login-attempts/failure-reasons`,
      requestConfig(token, params)
    );
    return response.data;
  },

  getTrends: async (token, params) => {
    const response = await axios.get(
      `${API_BASE_URL}/admin/login-attempts/trends`,
      requestConfig(token, params)
    );
    return response.data;
  },

  getUsers: async (token, params) => {
    const response = await axios.get(
      `${API_BASE_URL}/admin/login-attempts/users`,
      requestConfig(token, params)
    );
    return response.data;
  },

  getRecentAttempts: async (token, params) => {
    const response = await axios.get(
      `${API_BASE_URL}/admin/login-attempts/recent`,
      requestConfig(token, params)
    );
    return response.data;
  },
};

export default loginAnalyticsService;
